import React from "react";
import Banner from "../../Components/userComponents/Common/Banner";
import CareerEnhance from "../../Components/userComponents/CareerComponents/CareerEnhance";
import JobOpennings from "../../Components/userComponents/CareerComponents/JobOpennings";
import Benifits from "../../Components/userComponents/CareerComponents/Benifits";
import FaqSection from "../../Components/userComponents/CareerComponents/FaqSection";

const Career = () => {
  return (
    <div className="bg-[#FDF2F8]">
      <Banner page="Career" path="career" />
      <CareerEnhance />
      <JobOpennings />
      <Benifits />
      <FaqSection />
    </div>
  );
};

export default Career;
